import { Link } from "react-router-dom";
import type { DashboardOverview } from "@/types/dashboard";
import { formatDate, recommendationText, riskStyle } from "../labels";

export default function AttentionList({ items }: { items: DashboardOverview["attentionTrees"] }) {
  return (
    <section className="bg-white rounded-card border border-background-200 p-5 md:p-6">
      <div className="mb-4">
        <h3 className="text-base font-semibold text-foreground-900 font-heading">Precisam de atenção</h3>
        <p className="text-xs text-foreground-500 mt-0.5">Risco alto ou crítico na última vistoria validada</p>
      </div>
      {items.length === 0 ? (
        <div className="flex items-center gap-2 rounded-lg bg-primary-50 px-3 py-3 text-sm text-primary-800">
          <i className="ri-checkbox-circle-line text-lg" />
          Nenhum exemplar com risco alto ou crítico.
        </div>
      ) : (
        <ul className="divide-y divide-background-100">
          {items.map((t) => {
            const risk = riskStyle(t.riskClass);
            return (
              <li key={t.treeId}>
                <Link
                  to={`/cta/${t.treeId}`}
                  className="flex items-center gap-3 py-2.5 -mx-2 px-2 rounded-lg hover:bg-background-50 transition-colors"
                >
                  <span className="h-9 w-1 rounded-full shrink-0" style={{ backgroundColor: risk.color }} />
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-foreground-900 truncate">
                      {t.treeCode}
                      <span className="font-normal text-foreground-500"> · {t.speciesName ?? "Espécie não identificada"}</span>
                    </p>
                    <p className="text-xs text-foreground-500 truncate">
                      {recommendationText(t.primaryRecommendation)} · {formatDate(t.lastInspectionDate)}
                    </p>
                  </div>
                  <span
                    className="text-[11px] font-semibold rounded-full px-2 py-0.5 shrink-0"
                    style={{ backgroundColor: `${risk.color}1A`, color: risk.color }}
                  >
                    {risk.text}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
